/* eslint-disable prettier/prettier */
import { Box, BoxProps, ColorOptions, LoaderNew, SpacerNew, TextNew } from '@jfs/ui-new'
import { ModBox } from '../../../../comps/ModifiedBox/ModifiedBox'
import { Colors } from '../../../../util/util'

const SubmitUpdateButton = ({ onProceedPress, isUpdate, isLoading, ...props }: any) => {
  return (
    <Box flexDirection={'row'}>
      <ModBox {...styles.cancelButton(true, isUpdate)} onPress={props.onCancel}>
        <TextNew
          fontFamily="jiotype-medium"
          color="PRIMARY_GREY"
          fontSize={14}
          selectable={false}
          title={'Cancel'}
        />
      </ModBox>
      <SpacerNew size={15} direction="horizontal" />
      <ModBox
        {...styles.addReportButton(true, isUpdate)}
        //disabled={!props.isCurrentFormValid}
        testID="update-report"
        onPress={onProceedPress}>
        {isLoading ? (
          <LoaderNew color={'WHITE' as ColorOptions} />
        ) : (
          <TextNew
            fontFamily="jiotype-medium"
            color="WHITE"
            fontSize={14}
            selectable={false}
            title={props.isUpdate ? 'Update' : 'Submit'}
          />
        )}
      </ModBox>
    </Box>
  )
}

export default SubmitUpdateButton

const styles = {
  addReportButton: (isValid: boolean, isUpdate: boolean) =>
  ({
    borderRadius: 4,
    ph: 30,
    pv: 4,
    backgroundColor: isUpdate ? 'BLUE' : isValid ? Colors.REPORT_PRIMARY : 'rgba(34, 91, 208, 0.4)',
    underlayColor: isValid ? 'DISABLED_GREY' : 'BLUE',
    alignItems: 'center',
    opacity: isValid ? 1 : 0.5,
    alignSelf: 'center',
    justifyContent: 'center',
  } as BoxProps),
  cancelButton: (isValid: boolean, isUpdate: boolean) =>
  ({
    borderRadius: 4,
    ph: 30,
    pv: 4,
    backgroundColor: 'SECONDARY_GREY',
    underlayColor: 'DISABLED_GREY',
    alignItems: 'center',
    opacity: 1,
    alignSelf: 'center',
    justifyContent: 'center',
  } as BoxProps),
}
